import { takeLatest, all, put, call, select } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';

import AuthPanelActions from './actions';
import AuthPanelSelectors from './selectors';
import AuthPanelApi from '../api';

import authStatics from '../../../common/static';
import { minDurationEffect } from '../../../../../common/redux';

import _enums from '../../../common/enums';

function* forgetPasswordRedirectHandler() {
  yield call(() => (window.location.href = authStatics.AUTH_FORGOT_PASSWORD_PATH));
}

function* onLoginRequestHandler({ payload: { formRef, isValid } }) {
  formRef.method = 'post';
  if (isValid) {
    formRef.submit();
  } else {
    yield call(delay, 500);
    yield put(AuthPanelActions.onLoginRequestFailure());
  }
}

function* onEmailSubmitRequestHandler() {
  const email = yield select(AuthPanelSelectors.userFieldValue);
  const { error, ...response } = yield minDurationEffect(call(AuthPanelApi.verifyEmail, email));

  if (!!error) yield put(AuthPanelActions.onEmailSubmitRequestFailure(error));
  else {
    //A local list of form supporting login types. After validating the email, if our form respone is one of these, then we save it to state and let the react renders do their thing.
    const _formSupportedLoginTypes = [
      _enums.loginTypes.TYPE_FORM,
      _enums.loginTypes.TYPE_FORM2FA,
      _enums.loginTypes.CESSSO_TYPE,
      _enums.loginTypes.CESSSO_INVITED_TYPE,
    ];
    if (_formSupportedLoginTypes.indexOf(response.type) !== -1) {
      yield minDurationEffect(
        put(
          AuthPanelActions.onEmailSubmitRequestSuccess(
            response.type,
            response.secondaryLoginType,
            response.skipCountdown,
            response.supportUrl,
            response.url
          )
        )
      );
    } else if (response.type === _enums.loginTypes.CESSSO_REDIRECT_TYPE) {
      //hard redirect to Zeta Login login page for users who already have had their Zeta accounts upgraded and linked to their Grow App.
      yield call(() => (window.location.href = response.url));
    } else {
      //If the login type is not one of from the list,then that means we should get a URL to redirect to
      yield call(() => (window.location.href = response.url));
    }
  }
}

function* authFormSagas() {
  yield all([
    takeLatest(AuthPanelActions.forgetPasswordRedirect.getType(), forgetPasswordRedirectHandler),
    takeLatest(AuthPanelActions.onLoginRequest.getType(), onLoginRequestHandler),

    takeLatest(AuthPanelActions.onEmailSubmitRequest.getType(), onEmailSubmitRequestHandler),
  ]);
}

export default authFormSagas;
